import React from 'react';
import PromotionDF from '../components/SimulatorsComponents/DefualtSimulators/PromotionDF';

//= ========================================================================

const Sim_V02_promotion = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <PromotionDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_V02_promotion;
